import React from 'react';

import { makeClassNames } from '../../../utils/styles';
import MatchComment, { IMatchComment } from '../match-comment/match-comment';
import './match-comments-timeline.scss';

export interface IMatchCommentsTimeline {
  comments?: IMatchComment[];
  newPostsCount: number;
}

const classNames = () =>
  makeClassNames({
    Timeline: 'timeline',
    TimelineSection: 'timeline__section',
    TimelineWrapper: 'timeline__aside',
    TimelineDot: 'timeline__dot',
    TimelineDotActive: 'timeline__dot--active',
    TimelineLine: 'timeline__line',
    TimelineMain: 'timeline__main',
  });

const MatchCommentsTimeline: React.FC<IMatchCommentsTimeline> = ({
  comments = [] /* istanbul ignore next: default value */,
  newPostsCount,
}: IMatchCommentsTimeline) => {
  const cn = classNames();

  return (
    <div className={cn.Timeline}>
      {comments.map((comment, index) => {
        return (
          <section className={cn.TimelineSection} key={comment.commentId} id={comment.commentId}>
            <div className={cn.TimelineWrapper}>
              <div className={`${cn.TimelineDot} ${index < newPostsCount ? cn.TimelineDotActive : ''}`} />
              <div className={cn.TimelineLine} />
            </div>
            <div className={cn.TimelineMain}>
              <MatchComment {...comment} />
            </div>
          </section>
        );
      })}
    </div>
  );
};

export default MatchCommentsTimeline;
